import { RenderContainer } from "../RenderContainer";
import React from "react";
import { Renderer, Renderer2, RendererProps } from "../model";
import { ErrorM } from "components/helpers/FormHelpers/ErrorM";
import { useField } from "formik";

const CustomInteger: React.FC<RendererProps> = ({
  customField,
  index,
  readOnly,
  handleOnChange,
  field,
  isMulti,
  classWrapper,
}) => {
  const [{ value }] = useField(field.name);
  return (
    <RenderContainer
      customFieldName={customField.name}
      classWrapper={classWrapper}
      orderNumber={customField.orderNumber}
    >
      <React.Fragment>
        {handleOnChange && (
          <>
            <input
              className={`EditBox${readOnly ? " ViewOnly" : ""} ${
                classWrapper ? classWrapper : ""
              }`}
              value={
                readOnly
                  ? value[index].value
                    ? value[index].value
                    : "-"
                  : value[index].value
                  ? +value[index].value
                  : undefined
              }
              type={readOnly ? "text" : "number"}
              readOnly={readOnly}
              onChange={e => handleOnChange(e, index)}
              //   Stop the user entering decimals or standard form
              onKeyDown={evt =>
                (evt.key === "e" || evt.key === ".") && evt.preventDefault()
              }
            />
            <ErrorM name={customField.name} />
          </>
        )}
      </React.Fragment>
    </RenderContainer>
  );
};

export const customInteger: Renderer2 = (
  customField,
  index,
  readOnly,
  handleOnChange,
  field,
  isMulti,
  classWrapper,
  booleanField
) => (
  <CustomInteger
    customField={customField}
    index={index}
    readOnly={readOnly}
    handleOnChange={handleOnChange}
    field={field}
    isMulti={isMulti}
    classWrapper={classWrapper}
    booleanField={booleanField}
  />
);
